<ng-template #callToActionModal let-modal>
  <div class="modal-body blue-text-color">
    <div class="row">
      <div class="col-12">
        <img src="assets-front/images/image-cta-parcours-travaux.jpg" class="w-100" alt=""/>
      </div>
    </div>
    <h3 class="title">NOUVEAU : testez notre outil de simulation de travaux !</h3>
    <p> 🔧 CLÉA vous propose désormais un outil gratuit pour simuler les travaux de rénovation énergétique de votre
      maison.</p>
    <p> 📍 Renseignez l’adresse, recevez des scénarios personnalisés, priorisez vos travaux, et visualisez le gain sur
      votre DPE !</p>

    <div class="row justify-content-center mt-3">
      <div class="">
        <button type="button" (click)="goToParcoursTravaux()" class="btn btn-connexion w-100 mt-4 btn">👉 Je découvre
          l’outil
        </button>
      </div>
    </div>
    <div class="row">
      <div class="mb-3 col-12 text-end">
        <button type="button" class="action-btn btn btn-light me-1" (click)="close()">Fermer</button>
        <button type="button" class="action-btn btn btn-danger me-1" (click)="skipPoll()">Ne plus afficher</button>
      </div>
    </div>
  </div>
</ng-template>
